const longGames = [
  { id: '32', gTitle: 'Castles of Mad King' },
  { id: '7', gTitle: 'Egizia' },
  { id: '10', gTitle: 'Lords of Waterdeep' },
  { id: '12', gTitle: 'Puerto Rico' },
  { id: '13', gTitle: 'Ra' },
  { id: '18', gTitle: 'Stone Age' },
  { id: '38', gTitle: 'TTR World Maps' },
  { id: '21', gTitle: 'Vegas Showdown' },
];

export default longGames;
